import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    openingEffected: false,
    homeSwiperIndex: 0,
    pageChanger: 0,
    exhibitionPages: 0,
    exhibitionMaxPages: 0,
    pageControl: {
      lightTheme: false,
      left: false,
      right: false,
      up: false,
      down: false
    },
  },
  mutations: {
    setOpeningEffected(state, src) {
      state.openingEffected = src
    },
    setHomeSwiperIndex(state, src) {
      state.homeSwiperIndex = src
    },
    setExhibitionPages(state, src) {
      state.exhibitionPages = src
    },
    setExhibitionMaxPages(state, src) {
      state.exhibitionMaxPages = src
    },
    updatePageChanger(state) {
      state.pageChanger++
    },
    setPageControl(state, src) {
      if (!(state.pageControl.lightTheme == src.lightTheme && state.pageControl.left == src.left && state.pageControl.right == src.right && state.pageControl.up == src.up && state.pageControl.down == src.down)) {
        state.pageControl = src
      }
    },
  },
  actions: {
    doSetOpeningEffected({commit}, src) {
      commit('setOpeningEffected', src)
    },
    doSetHomeSwiperIndex({commit}, src) {
      commit('setHomeSwiperIndex', src)
    },
    doSetPageControl({commit}, src) {
      // console.log(src)
      commit('setPageControl', src)
    },
    doSetExhibitionPages({commit}, src) {
      // console.log(src)
      commit('setExhibitionPages', src)
    },
    doSetExhibitionMaxPages({commit}, src) {
      // console.log(src)
      commit('setExhibitionMaxPages', src)
    },
    doUpdatePageChanger({commit}, src) {
      commit('updatePageChanger', src)
    },
  },
  modules: {
  }
})
